import { TipoDeRegraDePermissao } from '@/models/RegraDeNegocio'
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds'
import { RouteConfig } from 'vue-router'

const rotasDeEnviosDeEmail: RouteConfig[] = [
	{
		path: 'registro-de-envios-de-email',
		name: 'Registro de envios de e-mail',
		components: {
			default: () => import('@/views/application/venda/TelaDeRegistroDeEnviosDeEmail.vue'),
			toolbar: () => import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: { toolbar: tituloDaToolbarPeloNomeDaRota },
		meta: {
			regraDeNegocio: 'consultar-registro-de-envios-de-email' as TipoDeRegraDePermissao,
		},
	},
]

export default rotasDeEnviosDeEmail
